export default __webpack_public_path__ + "media/images/brighteon-social/logo_horiz-14f3564e85c4d54d9e85cc99ae903242.svg";